export default "__VITE_ASSET__Bd8NAOR0__"